import { ShieldCheck, Star } from "lucide-react";
import { COMPANY, surveyUrl } from "@/lib/company";

export default function ReceiptVerify() {
  const params = new URLSearchParams(window.location.search);
  const receiptNo = params.get("fis") || "";
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-emerald-50 via-white to-white px-4 py-10" data-testid="receipt-verify-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-lg">
        <ShieldCheck className="mx-auto h-16 w-16 text-emerald-500" />
        <h1 className="mt-4 font-heading text-2xl font-black text-emerald-700">{COMPANY.brand}</h1>
        <p className="mt-1 text-sm text-slate-500">{COMPANY.legal}</p>
        <div className="mt-6 rounded-2xl bg-emerald-50 p-5">
          <p className="text-xs uppercase tracking-wide text-emerald-600">Fiş / Belge No</p>
          <p className="mt-1 font-heading text-xl font-black text-slate-900" data-testid="receipt-verify-no">
            {receiptNo || "—"}
          </p>
          <p className="mt-2 text-sm text-slate-600">Bu belge {COMPANY.brand} tarafından düzenlenmiştir.</p>
        </div>
        <a
          href={surveyUrl(receiptNo)}
          data-testid="receipt-verify-survey-link"
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-xl bg-amber-500 px-5 py-3 font-semibold text-white shadow-sm transition-colors hover:bg-amber-600"
        >
          <Star className="h-5 w-5" /> Alışverişinizi değerlendirin
        </a>
        <p className="mt-6 text-xs text-slate-400">{COMPANY.address} · {COMPANY.web}</p>
      </div>
    </div>
  );
}
